'use strict';

class Analytics {
    constructor () {
        this.helper = require('./helpers/helper');
        this.listing = require('./listing');
        this.quickImpressionSender = require('./helpers/quickImpressions');
        this.logName = 'Analytics';

        this.testMode = this.helper.isTestEnabled();
    }
    init (globalContainer, helperContainer) {
        this.globalContainer = globalContainer;
        this.helperContainer = helperContainer;
        this.helperData = this.helperContainer.data();

        if (this.testMode) {
            console.info(this.logName + ' Initialized!');
        }
    }

    log (data, inline = false) {
        if (!this.testMode) {
            return;
        }
        if (inline) {
            console.info(this.logName + ': ' + data);
        } else {
            console.info(this.logName + ': ');
            console.info(data);
        }
    }

    push (pushObject) {
        this.log(pushObject);
        this.helper.push(pushObject, false);
    }

    generateAnalyticsSku (notifyMe = false) {
        let sku = '';

        let id = '';
        if (!$('.analytics.product').length) {
            id = $('.analytics.product').data('item_id');
        } else {
            id = $('.product-wrapper').data('master-pid').split('_')[0];
        }

        let color = $('.swatch-circle.selected').data('attr-value');

        let size = '';
        if (notifyMe) {
            size = $('[data-attr="size"] input.clicked-size').attr('data-attr-value');
        } else {
            size = $('[data-attr="size"] input:checked').attr('data-attr-value');
        }

        if (color && size) {
            sku = id + '_' + color + '_' + size;
        } else if (color) {
            sku = id + '_' + color;
        }

        sku = sku.trim();

        return sku.toUpperCase();
    }
};

module.exports = Analytics;
